/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type CustomerImpact = typeof CustomerImpact[keyof typeof CustomerImpact];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerImpact = {
  Yes: 'Yes',
  No: 'No',
} as const;
